<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row>
      <v-col lg="4">
        <account-customer-dialog
          :account="selectedAccount"
          :dialog-visible="dialogVisible"
          @close="dialogVisible = false"
        />
        <account-customer-correction-dialog
          :account="selectedCorrectionAccount"
          :dialog-visible="dialogCorrectionVisible"
          @close="dialogCorrectionVisible = false"
        />
      </v-col>
    </v-row>
    <v-row

      justify="center"
    >
      <v-col>
        <base-material-card>
          <template v-slot:heading>
            <div class="text-subtitle-1 font-weight-light">
              Программа лояльности
            </div>
            <div class="text-h6 font-weight-light">
              {{ account.campaign.name }}
            </div>
          </template>
          <v-card-text>
            <v-row>
              <v-col
                cols="7"
                lg="4"
                md="4"
                sm="6"
              >
                <v-text-field
                  v-model="account.accountAccrual.amount "
                  label="Дебит (списание бонусов)"
                  readonly
                />
              </v-col>
              <v-col
                class="d-flex justify-center align-center"
                cols="1"
                lg="2"
                md="2"
                sm="2"
              >
                <v-btn
                  v-if="role===2"
                  color="blue lighten-5 blue--text text--darken-1"
                  @click="openCorrectionDialog(account)"
                >
                  Добавить
                </v-btn>
              </v-col>
              <v-col
                cols="7"
                lg="4"
                md="4"
                sm="6"
              >
                <v-text-field
                  v-model="account.accountEmission.amount"
                  label="Кредит (начисление бонусов)"
                  readonly
                />
              </v-col>
              <v-col
                class="d-flex justify-center align-center"
                cols="1"
                lg="2"
                md="2"
                sm="2"
              >
                <v-btn
                  v-if="role===2"
                  color="blue lighten-5 blue--text text--darken-1"
                  @click="openDialog(account)"
                >
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-center align-center">
            <v-btn
              color="primary"
              outlined
              @click="$router.back()"
            >
              Назад
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountCustomerDialog from "./AccountCustomerDialog"
import AccountCustomerCorrectionDialog from "./AccountCustomerCorrectionDialog"
import AccountListViewModel from "@/views/loyalty/models/account-list-view.model"
import WebApi from "@/views/loyalty/shared/modules/web_api"
import { AccountService } from "@/views/loyalty/shared/services/account-service"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"

export default {
  name: "AccountCustomerEdit",
  components: {
    AccountCustomerDialog,
    AccountCustomerCorrectionDialog
  },
  data: () => ({
    account: Reflect.construct(AccountListViewModel, []),
      accountService: null,
    dialogVisible: false,
    dialogCorrectionVisible: false,
      justpayClientService: null,
    role: 0,
    selectedAccount: {},
    selectedCorrectionAccount: {},
    webApi: null
  }),
  async beforeMount () {
      this.accountService = new AccountService()
      this.justpayClientService = new JustpayClient()
    this.webApi = new WebApi(this.$store)
        .editError("Данные счёта не записаны")
        .editSuccess("Данные счёта записаны")
        .readError("Данные счёта не считаны")
    this.role = +this.$route.params.role
    await this.getItems()
  },
  methods: {
    async getItems () {
      const campaignId = +this.$route.params.campaign
      const customerId = this.$route.params.customer
        const customerNumber = await this.justpayClientService.getClientNumber(customerId)
        const account = await this.accountService.getAllCampaignCustomerAccount(campaignId, customerNumber)

        this.account = Reflect.construct(AccountListViewModel, [
          account.campaign,
          account.accountAccrual,
          account.accountEmission
        ])
    },
    openCorrectionDialog (account) {
      // console.log(account);
      this.dialogCorrectionVisible = true
      this.selectedCorrectionAccount = account
    },
    openDialog (account) {
      console.log(account)
      this.dialogVisible = true
      this.selectedAccount = account
    }
  }
}
</script>

<style scoped></style>
